import { ButtonIcon as GSButtonIcon } from "@gluestack-ui/themed";

import { IButtonIcon } from "./types";
import { Icon } from "@repo/core/components/core/Icon";

export const ButtonIcon = ({
  name,
  color,
  size,
  variant = "regular",
  ...rest
}: IButtonIcon) => {
  return (
    <GSButtonIcon
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
      as={({ size: _iconSize, ...props }: any) => (
        <Icon
          name={name}
          size={size}
          color={color}
          variant={variant}
          {...props}
        />
      )}
      {...rest}
    />
  );
};
